// Таблица соседних маршрутов для edge-swipe навигации на мобиле.
// Ключ — текущий pathname, значение — массив соседей в порядке свайпа.
// Свайп влево (от правого края) идёт к next, свайп вправо (от левого края) — к prev.
// Первый <-> последний закольцованы.

export const MOBILE_NAV_GROUPS: Record<string, string[]> = {
  // Документы
  '/documents':       ['/documents', '/documents/scan'],
  '/documents/scan':  ['/documents', '/documents/scan'],
  // Честный Знак
  '/marking/scan':    ['/marking/scan', '/marking/bulk', '/marking/history'],
  '/marking/bulk':    ['/marking/scan', '/marking/bulk', '/marking/history'],
  '/marking/history': ['/marking/scan', '/marking/bulk', '/marking/history'],
};

export function siblingsOf(path: string): string[] | null {
  return MOBILE_NAV_GROUPS[path] ?? null;
}

export function nextSibling(path: string): string | null {
  const siblings = siblingsOf(path);
  if (!siblings) return null;
  const i = siblings.indexOf(path);
  if (i < 0) return null;
  return siblings[(i + 1) % siblings.length];
}

export function prevSibling(path: string): string | null {
  const siblings = siblingsOf(path);
  if (!siblings) return null;
  const i = siblings.indexOf(path);
  if (i < 0) return null;
  return siblings[(i - 1 + siblings.length) % siblings.length];
}
